import { FEATURE_SUSTAINABLE_ID } from '@/utility/constants';
import { CompositionListItem } from '@/utility/searchMappingHelpers';

// MP List

export const isSustainable = ({ labels }: AssortmentListProductType) => {
  return labels?.some((label) => label.id === FEATURE_SUSTAINABLE_ID);
};

export const isEmbroidery = (composition: CompositionListItem) => {
  return composition.isEmbroidery;
};

export const isCompositionNew = (composition: CompositionListItem) => {
  const publishingDate = new Date(Number(composition.creationDate)).getTime();
  const today = Date.now();
  const millisecondsIn30Days = 30 * 24 * 60 * 60 * 1000;

  return today - publishingDate < millisecondsIn30Days;
};

// MP Detail

export const isSustainableProductType = (productType: ProductType): boolean[] | undefined => {
  return productType.labels?.features.map((label) => label.id === FEATURE_SUSTAINABLE_ID);
};

export const isEmbroideryProductType = (
  compositionData: Pick<Composition, 'embroidery'>
): boolean | undefined => {
  return compositionData.embroidery;
};

export const isNewProductType = (
  compositionData: Pick<Composition, 'publishingDate'>
): boolean | undefined => {
  const publishingDate = new Date(compositionData.publishingDate).getTime();
  const today = Date.now();
  const millisecondsIn30Days = 30 * 24 * 60 * 60 * 1000;

  return today - publishingDate < millisecondsIn30Days;
};
